function convertDuration (duration: number): number {
  
  return Math.floor(duration / 60)

}

export default convertDuration
